import type { Locale } from 'date-fns';
import { de, enUS, es, fr, id, ja, nl, pl, ptBR, ru } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

type Languages = Record<
  string,
  {
    name: string;
    // TODO: new source of language tags since stripe removal?
    ietfLanguageTag: 'en' | 'ja' | 'de' | 'id' | 'es-419' | 'fr' | 'pt-BR' | 'pl' | 'nl' | 'ru';
    dateFnsLocale: Locale;
    /**
     * beta - beta languages only show in dev environment
     */
    beta?: boolean;
  }
>;

export const LANGUAGES: Languages = {
  en: {
    name: 'English',
    ietfLanguageTag: 'en',
    dateFnsLocale: enUS,
  },
  ja: {
    name: '日本語',
    ietfLanguageTag: 'ja',
    dateFnsLocale: ja,
  },
  de: {
    name: 'Deutsch',
    ietfLanguageTag: 'de',
    dateFnsLocale: de,
  },
  id: {
    name: 'Bahasa Indonesia',
    ietfLanguageTag: 'id',
    dateFnsLocale: id,
  },
  es: {
    name: 'Español',
    ietfLanguageTag: 'es-419',
    dateFnsLocale: es,
  },
  fr: {
    name: 'Français',
    ietfLanguageTag: 'fr',
    dateFnsLocale: fr,
  },
  pt: {
    name: 'Português',
    ietfLanguageTag: 'pt-BR',
    dateFnsLocale: ptBR,
  },
  pl: {
    name: 'Polski',
    ietfLanguageTag: 'pl',
    dateFnsLocale: pl,
  },
  nl: {
    name: 'Nederlands',
    ietfLanguageTag: 'nl',
    dateFnsLocale: nl,
  },
  ru: {
    name: 'Русский',
    ietfLanguageTag: 'ru',
    dateFnsLocale: ru,
  },
  cimode: {
    name: 'No-op',
    ietfLanguageTag: 'en',
    dateFnsLocale: enUS,
    beta: true,
  },
} as const;

const useLanguage = () => {
  const { i18n } = useTranslation();

  const languageCode = i18n.resolvedLanguage ?? 'en';

  return {
    language: LANGUAGES[languageCode],
    i18n,
  };
};

export default useLanguage;
